/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VendorErrorImpactedComponent = {
    Controller: 'controller',
    PilotSignalCircuit: 'pilot_signal_circuit',
    Firmware: 'firmware',
    TemperatureSensor: 'temperature_sensor',
    EnergyMeter: 'energy_meter',
    HumiditySensor: 'humidity_sensor',
    Microcomputer: 'microcomputer',
    DisplayScreen: 'display_screen',
    LedStatusIndicators: 'led_status_indicators',
    PushButton: 'push_button',
    Keypad: 'keypad',
    RotarySwitch: 'rotary_switch',
    AuthenticationModule: 'authentication_module',
    Buzzer: 'buzzer',
    PaymentTerminal: 'payment_terminal',
    PowerLineCommunicationModule: 'power_line_communication_module',
    NetworkInterface: 'network_interface',
    InternalBus: 'internal_bus',
    GatewayModule: 'gateway_module',
    PowerConnector: 'power_connector',
    Contactor: 'contactor',
    PowerModule: 'power_module',
    AcDcConverter: 'ac_dc_converter',
    Transformer: 'transformer',
    MainIsolator: 'main_isolator',
    Battery: 'battery',
    Fuse: 'fuse',
    CircuitBreaker: 'circuit_breaker',
    SurgeProtectiveDevice: 'surge_protective_device',
    AuxiliaryPowerSupply: 'auxiliary_power_supply',
    CoolingFan: 'cooling_fan',
    Heatsink: 'heatsink',
    InternalHeater: 'internal_heater',
    LiquidCoolingUnit: 'liquid_cooling_unit',
    Coolant: 'coolant',
    AirInlet: 'air_inlet',
    AirFilter: 'air_filter',
    AirOutlet: 'air_outlet',
    Enclosure: 'enclosure',
    Chassis: 'chassis',
    InletPlugDock: 'inlet_plug_dock',
    GlandsSeals: 'glands_seals',
    CableRetractor: 'cable_retractor',
    Door: 'door',
    LockMechanism: 'lock_mechanism',
    MountingSystem: 'mounting_system',
    OpeningSensor: 'opening_sensor',
    RcdProtection: 'rcd_protection',
    GroundMonitor: 'ground_monitor',
    EStop: 'e_stop',
    InsulationMonitor: 'insulation_monitor',
    ChargerLock: 'charger_lock',
    SafetyInterlockCircuit: 'safety_interlock_circuit',
    Grid: 'grid',
    Environment: 'environment',
    Ev: 'ev',
    IdentificationMeans: 'identification_means',
    User: 'user',
    Ground: 'ground',
    Backend: 'backend',
    SiteInfrastructure: 'site_infrastructure'
} as const;
export type VendorErrorImpactedComponent = typeof VendorErrorImpactedComponent[keyof typeof VendorErrorImpactedComponent];


export function instanceOfVendorErrorImpactedComponent(value: any): boolean {
    for (const key in VendorErrorImpactedComponent) {
        if (Object.prototype.hasOwnProperty.call(VendorErrorImpactedComponent, key)) {
            if (VendorErrorImpactedComponent[key as keyof typeof VendorErrorImpactedComponent] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VendorErrorImpactedComponentFromJSON(json: any): VendorErrorImpactedComponent {
    return VendorErrorImpactedComponentFromJSONTyped(json, false);
}

export function VendorErrorImpactedComponentFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorErrorImpactedComponent {
    return json as VendorErrorImpactedComponent;
}

export function VendorErrorImpactedComponentToJSON(value?: VendorErrorImpactedComponent | null): any {
    return value as any;
}

export function VendorErrorImpactedComponentToJSONTyped(value: any, ignoreDiscriminator: boolean): VendorErrorImpactedComponent {
    return value as VendorErrorImpactedComponent;
}

